import { Outlet } from "react-router-dom";

const MobilityStations = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default MobilityStations;